<div class="ols-info">
  <div class="ols-info-icon">
    <div class="icon-verz ial-al_017"></div>
  </div>
  <div>
    <div class="ols-title">{{vraag.titel}}</div>
    <div *ngIf="vraag.vraagregels && vraag.vraagregels.length > 0" class="ols-vraag-regels">
      <span *ngFor="let regel of vraag.vraagregels" innerHTML="{{regel}}"></span>
    </div>
  </div>
</div>